import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const addFilterServiceProviderandPropertyDeveloperList = (serviceRequest, { payload }) => {
  return {
    payload,
  };
}

const clearFilterServiceProviderandPropertyDeveloperList = () => {
  return initialState;
};

let initialState ={payload:[]};

export default createReducer(initialState, {
  [TYPES.CLEAR_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER]: clearFilterServiceProviderandPropertyDeveloperList,
  [TYPES.ADD_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER]: addFilterServiceProviderandPropertyDeveloperList,
});
